import { useEffect } from "react";

const SITE_URL = "https://www.clevencleaning.nl";
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-cleven-cleaning.jpg`;

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Imperative SEO head manager (reliable on React 19, no react-helmet dependency).
 * Upserts title, description, canonical, OpenGraph & Twitter tags in place so the
 * static homepage tags in index.html are updated rather than duplicated.
 * Per-route JSON-LD is injected as a removable <script> tag.
 */
const SEO = ({
  title = "Cleven Cleaning | Professionele Glazenwasser Rosmalen en Omstreken",
  description = "Cleven Cleaning is uw vakkundige glazenwasser in Rosmalen en omstreken. Glasbewassing, zonnepaneel reiniging, kozijn reiniging en meer. 4.8 sterren op Google. Bel 06-83653511!",
  canonicalUrl = `${SITE_URL}/`,
  image = DEFAULT_OG_IMAGE,
  jsonLd = null,
}) => {
  useEffect(() => {
    document.title = title;
    upsertMeta("name", "description", description);
    upsertLink("canonical", canonicalUrl);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta("property", "og:image", image);

    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", image);
    upsertMeta("name", "twitter:url", canonicalUrl);

    let script = null;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo-jsonld", "true");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    return () => {
      if (script && script.parentNode) script.parentNode.removeChild(script);
    };
  }, [title, description, canonicalUrl, image, jsonLd]);

  return null;
};

export default SEO;
